<template>
    <div class="mx-3 mt-3">
        <h3>Operadora</h3>

        <template v-if="listas">

            <div class="card dashcard mb-0">

                <div class="card-body">

                    <div class="form-row">
                        <div class="col col-12 col-md-6">
                            <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                        </div>

                        <div class="col col-12 col-md-3">
                            <az-input  
                                icon="fa fa-building-o fa-fw"
                                type="select"
                                placeholder="Todas as Unidades..."
                                :optionsList="listas.unidades"
                                optionsData="id_unidade_operacao"
                                v-model="search" />
                        </div>

                        <div class="col col-12 col-md-3">
                            <az-input  
                                icon="fas fa-briefcase-medical fa-fw"
                                type="select"
                                placeholder="Todas as Especialidades..."
                                :optionsList="listas.especialidades"
                                optionsData="id_especialidade"
                                v-model="search" />
                        </div>
                    </div>

                    <div class="form-row mt-2">
                        <div class="col col-12">
                            <az-input  
                                icon="fas fa-search fa-fw"
                                placeholder="Pesquisar..."
                                v-model="search" />
                        </div>
                    </div>

                </div>

            </div>
            <!-- Fim Header -->

            <div class="progress mt-1 mb-3">
                <div class="indeterminate" v-if="$store.state.loading && dados"></div>
                <div class="determinate" v-else></div>
            </div>

        </template>

        <template v-if="false">
            <button type="button" class="btn btn-primary" @click="init()">
                Inicializar
            </button>

            <button type="button" class="btn btn-primary mb-3" @click="load()">
                Carregar
            </button>
        </template>

        <div class="d-flex justify-content-center">
            <ul class="nav nav-pills" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Geral</a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Especialidades</a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Médicos</a>
                </li>
            </ul>
        </div>
        
        <div class="tab-content" id="myTabContent">
            <!-- Geral -->
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                <div class="mt-3 row" v-if="dados">
                    <div class="col col-12 col-md-4">
                        <div class="card">
                            <div class="card-header bg-primary text-white lead">
                                Custo por Consulta
                            </div>
                            <div class="card-body">
                                <h2>
                                    <small class="text-muted">R$</small>
                                    <div class="display-4" v-if="total_consultas > 0">
                                        {{ $util.formatMoeda(geral_custo_interno / total_consultas) }}
                                    </div>
                                    <div class="display-4" v-else>
                                        ---
                                    </div>
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-3" v-if="dados && dados.consultas">
                    <div class="card">
                        <div class="card-header bg-primary text-white lead">
                            Consultas
                        </div>
                        <div class="card-body">
                            <div class="card-deck" v-for="(consulta, icx) in dados.consultas" :key="icx">
                                <div class="card">
                                    <div class="card-header">
                                        Consultas Realizadas
                                    </div>
                                    <div class="card-body d-flex justify-content-between">
                                        <div class="display-4">{{ consulta.quantidade }}</div>
                                        <div>
                                            <i class="fas fa-briefcase-medical fa-2x"></i>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        Pacientes Atendidos
                                    </div>
                                    <div class="card-body d-flex justify-content-between">
                                        <span class='display-4'>
                                            {{ consulta.paciente_dia }}
                                        </span>
                                        <div>
                                            <i class="fas fa-user-friends fa-2x"></i>
                                        </div>
                                    </div>
                                </div>

                                <div class="card" v-if="consulta.paciente_dia > 0">
                                    <div class="card-header">
                                        Consultas / Pacientes
                                    </div>
                                    <div class="card-body">
                                        <span class='display-4' v-if="consulta.paciente_dia > 0">
                                            {{ $util.formatMoeda(consulta.quantidade / consulta.paciente_dia) }}
                                        </span>
                                        <span class='display-4' v-else>
                                            ---
                                        </span>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        Ticket Médico
                                    </div>
                                    <div class="card-body">
                                        <h2>
                                            <small class="text-muted">R$</small>
                                            {{ $util.formatMoeda(consulta.valor_medio) }}
                                        </h2>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        Total
                                    </div>
                                    <div class="card-body">
                                        <h2>
                                            <small class="text-muted">R$</small>
                                            {{ $util.formatMoeda(consulta.valor_total) }}
                                        </h2>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    

                </div>

                <div class="mt-3" v-if="dados && dados.exames">
                    <div class="card">
                        <div class="card-header bg-primary text-white lead">
                            Exames
                        </div>
                        <div class="card-body">
                            <div class="card-deck mb-3" v-for="(exame, icx) in dados.exames" :key="icx">
                                <div class="card">
                                    <div class="card-header">
                                        {{ exame.origem }}
                                    </div>
                                    <div class="card-body">
                                        <div class="display-4">{{ exame.quantidade }}</div>
                                        <small class="text-muted">
                                            {{ percentual(dados.exames, exame, 'quantidade') }}%
                                        </small>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        Pacientes
                                    </div>
                                    <div class="card-body">
                                        <span class='display-4'>
                                            {{ exame.paciente_dia }}
                                        </span>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        Exames / Paciente
                                    </div>
                                    <div class="card-body">
                                        <span class='display-4' v-if="exame.paciente_dia > 0">
                                            {{ $util.formatMoeda(exame.quantidade / exame.paciente_dia) }}
                                        </span>
                                        <span v-else>
                                            ---
                                        </span>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        Ticket Médico
                                    </div>
                                    <div class="card-body">
                                        <h2>
                                            <small class="text-muted">R$</small>
                                            {{ $util.formatMoeda(exame.valor_medio) }}
                                        </h2>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header">
                                        Total
                                    </div>
                                    <div class="card-body">
                                        <h2>
                                            <small class="text-muted">R$</small>
                                            {{ $util.formatMoeda(exame.valor_total) }}
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <br><br><br><br><br>

            </div>

            <!-- Especialidades -->
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                <pre class="alert alert-secondary">{{ dados }}</pre>    
            </div>

            <!-- Médicos -->
            <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">...</div>
        </div>

        
    </div>
</template>

<script>
import _ from 'lodash';
import AzPeriodo from '../shared/forms/AzPeriodo.vue';
import AzInput from '../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            dados: null, 
            listas: null, 
            filtro: { 
                periodo: 'ma',
            },
            search: "", 
        }
    },

    components: { 
        AzPeriodo,
        AzInput, 
    },

    computed: { 
        geral_custo_interno: function () { 
            if ( !this.dados )
                return 0;

            let consultas = _.sumBy(this.dados.consultas, 'valor_total');
            let exames = _.sumBy(this.dados.exames.filter(item => item.origem == 'Interno'), 'valor_total');

            return parseFloat(consultas) + parseFloat(exames);
        },

        total_consultas: function () {
            if ( !this.dados )
                return 0;

            return _.sumBy(this.dados.consultas, 'quantidade');
        }
    },

    methods: { 
        percentual (lista, item, campo) { 
            let total = _.sumBy(lista, campo);

            return total > 0 ? ( ( _.get(item, campo) / total ) * 100 ) : 0;
        },

        init() { 
            this.axios.get('/externo/operadora/index')
                .then(res => { 
                    console.log(res);
                    this.listas = res.data;
                });
        },

        load() { 
            this.$store.commit('loading', true); 

            this.axios.post('/externo/operadora/dados', this.filtro)
                .then(res => {
                    this.dados = res.data;
                })
                .finally(() => { 
                    this.$store.commit('loading', false); 
                });
        }
    },

    mounted() { 
        this.init();
    }
}
</script>